export const PROPERTY_USE_OPTIONS = [
  { value: "Industrial", label: "Industrial" },
  { value: "Comercial", label: "Comercial" },
  { value: "Casa Habitación", label: "Casa Habitación" },
  { value: "Oficina", label: "Oficina" },
  { value: "Bodega", label: "Bodega" },
] as const;

export const VALID_PROPERTY_USE_VALUES: string[] = PROPERTY_USE_OPTIONS.map(
  (option) => option.value,
);

export type PropertyUseValue = (typeof PROPERTY_USE_OPTIONS)[number]["value"];
